import React from "react";
import { appColors, appRadius, appType } from "../../utils/appTheme";
import IconBox from "./IconBox";

/**
 * Ítem de lista. variant: "card" (fondo surface2, para filas de acción) | "row" (hairline).
 * Estructura: [iconBox] título/subtítulo ......... [value / trailing / chevron]
 */
const ListItem = ({
  icon,
  title,
  subtitle,
  subtitleColor = appColors.ink2,
  value,
  trailing,
  onClick,
  variant = "card",
  style,
}) => {
  const isCard = variant === "card";
  const Comp = onClick ? "button" : "div";

  return (
    <Comp
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        width: "100%",
        textAlign: "left",
        cursor: onClick ? "pointer" : "default",
        padding: isCard ? "14px 15px" : "12px 0",
        borderRadius: isCard ? appRadius.button : 0,
        background: isCard ? appColors.surface2 : "transparent",
        border: "none",
        borderBottom: isCard ? "none" : `1px solid ${appColors.line2}`,
        ...style,
      }}
    >
      {icon && <IconBox icon={icon} size={38} />}
      <span style={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0, flex: 1 }}>
        {title && <span style={{ ...appType.body, fontSize: 14 }}>{title}</span>}
        {subtitle && (
          <span style={{ ...appType.bodySm, color: subtitleColor }}>{subtitle}</span>
        )}
      </span>
      {value != null && (
        <span
          style={{
            ...appType.body,
            fontSize: 15,
            fontVariantNumeric: "tabular-nums",
            whiteSpace: "nowrap",
          }}
        >
          {value}
        </span>
      )}
      {trailing}
    </Comp>
  );
};

export default ListItem;
